import React, { useContext } from "react";
import { ThemeContext } from "../lib/main-context";
import { useTranslation } from "../i18n/TranslationProvider";
import { translateOr, translateTrigger } from "../i18n/translateData";

import { useHistory, useLocation } from "react-router-dom";

import { parse } from "date-fns";

import theme from "../index.scss";
import ComponentWrapper from "./DashboardComponents/ComponentWrapper";
import SubmitButton from "./StyledComponents/SubmitButton";

import getDaysAgo from "../lib/getDaysAgo";

import ReactECharts from "echarts-for-react";

const TriggerDetailsChart = ({ user, error, topSymptoms, data, retry }) => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();

  const history = useHistory();
  const location = useLocation();

  // Access the parameters from location.state if available,
  // otherwise provide default values
  const triggerType = location.state?.triggerType;
  const fromTriggerDetailsChart =
    location.state?.fromTriggerDetailsChart || false;
  const days = location.state?.days || 7;

  const filteredData = data
    ?.filter(
      (obj) =>
        obj.category == "SDOH" &&
        (obj.subcategory == `${triggerType.toLowerCase()}` ||
          obj.subcategory == `${triggerType}`)
    )
    .filter(
      (obj) =>
        parse(obj.symptom_date.slice(0, 10), "yyyy-MM-dd", new Date()) >
        getDaysAgo(days)
    );
  const count = {};
  filteredData.forEach((item) => {
    const element = item.factor;
    count[element] = (count[element] || 0) + 1;
  });
  const result = Object.entries(count).map(([name, value]) => ({
    name,
    value,
  }));
  const sorted = result.sort((a, b) => b.value - a.value);

  // Translate triggerType for title and y-axis
  const translatedTriggerType = translateOr(t, `dashboard.triggerCategory.${triggerType}`, triggerType);


  const option = {
    title: {
      text: t("dashboard.triggerSelector.details", { name: translatedTriggerType }),
      left: "center",
      textStyle: {
        fontSize: 24,
        color: dark ? theme.darkModeText : theme.black,
      },
    },
    tooltip: {
      trigger: "item",
    },
    xAxis: {
      type: "value",
      axisLabel: {
        fontSize: 16, // Change the font size here
        color: dark ? theme.darkModeText : theme.black,
      },
    },
    grid: {
      left: "5%", // Adjust the left padding here
      containLabel: true,
    },
    yAxis: {
      type: "category",
      axisLabel: {
        fontSize: 16, // Change the font size here
        color: dark ? theme.darkModeText : theme.black,
      },
      // Display only — counts stay keyed by the English factor
      data: sorted.map((item) => translateTrigger(t, item.name)).reverse(),
    },
    series: [
      {
        data: sorted.map((item) => item.value).reverse(),
        type: "bar",
      },
    ],
  };
  return (
    <>
      {error && (
        <ComponentWrapper>
          {t("dashboard.charts.error.0")}
          <SubmitButton onClick={retry}>
            {t("dashboard.charts.error.1")}
          </SubmitButton>
        </ComponentWrapper>
      )}

      <ComponentWrapper>
        <ReactECharts option={option} style={{ minHeight: "40vh" }} />
      </ComponentWrapper>

      <SubmitButton
        onClick={() => {
          if (user.userType !== "provider") {
            history.push("/");
          } else if (fromTriggerDetailsChart) {
            history.push({ pathname: "/charts", state: { days: days } });
          } else {
            history.push("/");
          }
        }}
      >
        {t("dashboard.goBack")}
      </SubmitButton>
    </>
  );
};

export default TriggerDetailsChart;